
import store from '@/store'
import Vue from "vue";

export default {
  path: '/cis/:eventId',
  component: () => import(/* webpackChunkName: "cis" */ '@/components/wrapper.vue'),
  children: [{
    path: '/',
    component:  () => import(/* webpackChunkName: "cis" */ '@/app/appLayout.vue'),
    props: { showMenu: false },
    children: [
      { path: 'sessions', name: 'cis.sessions', redirect: { name: 'observer.home' } },
      {
        path: '/',
        name: 'observer.home',
        component:  () => import(/* webpackChunkName: "cis" */ 'client/cis/components/sessions.vue'),
        beforeEnter: function (to, from, next) {
          store.dispatch('environment.setTitle', Vue.i18n.t('cis')).then(next)
        },
      }
    ]
  }, {
    path: 'session/:sessionId',
    component:  () => import(/* webpackChunkName: "cis" */ '@/app/appLayout.vue'),
    beforeEnter: function (to, from, next) {
      console.log('entering session', to.params.sessionId)
      const session = store.state.sessions.items.find(i => i.id === to.params.sessionId )
      const ed = store.state.eventDisciplines.items.find(i => i.id === session.eventDisciplineId)
      const title = ed.shortName || ed.name
      store.dispatch('environment.setTitle', title + ' - ' + session.name).then(() => {
        if (to.name === 'cis.session') {
          // find first active rotation
          let r = session.rotationsSet.find(r => r.status === 'active')
          let rotation = 0
          if (r) {
            console.log('found active rotation', r)
            rotation = r.index
          } else {
            r = session.rotationsSet.find(r => r.status === 'scheduled')
            console.log('found scheduled rotation', r)
            if (r) {
              rotation = r.index
            }
          }
          next({name: 'cis.session.panels', params: {sessionId: to.params.sessionId, rotation}})
        }
        else {
          next()
        }
      })
    },
    children: [
      {
        path: '/',
        components: {
          default: () => import(/* webpackChunkName: "cis" */ '@/components/wrapper.vue'),
          menu: () => import(/* webpackChunkName: "cis" */ './menu.vue')
        },
        children: [{
          path: '/',
          name: 'cis.session',
          component: () => import(/* webpackChunkName: "cis" */ '@/cis/components/session.vue'),
          children: [
            {
              path: ':rotation',
              name: 'cis.session.panels',
              component: () => import(/* webpackChunkName: "cis" */ '@/cis/components/panels.vue'),
            }
          ]
        }, {
          path: 'results',
          component: () => import(/* webpackChunkName: "cis" */ '@/components/wrapper.vue'),
          children: [{
            path: '/',
            name: 'cis.session.results',
            component: () => import(/* webpackChunkName: "cis" */ '@/cis/components/rankings.vue'),
          }, {
            path: 'category/:categoryId',
            component: () => import(/* webpackChunkName: "cis" */ '@/cis/components/category.vue'),
            children: [{
              path: '/',
              name: 'cis.category',
              component: () => import(/* webpackChunkName: "cis" */ '@/cis/components/categoryDummy.vue'),
            }, {
              path: 'ranking/:rankingId',
              name: 'cis.ranking',
              component: () => import(/* webpackChunkName: "cis" */ '@/cis/components/ranking.vue'),
            }]
          }]
        }]
      }
    ],
  }]
}
